export enum ChatThreadParticipantType {
  SYSTEM = 0,
  PATIENT = 1,
  CLINICIAN = 2,
  RELATED_PERSON = 3
}
